import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Tooltip } from 'react-tippy'
import ExecutiveSummaryMultipleBarLineChart from '../../../../components/Charts/ExecutiveSummary/ExecutiveSummaryMultipleBarLineChart'
import { ThemeContext } from '../../../../context';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { DefaultFilter } from '../../../../components/Filters/common';
import { eventTracking, MixpanelEvents } from '../../../../utils/userTracking';
import { closeFilterOptions } from '../../../../components/Filters/subs/helpers';
import { useQuery } from '@tanstack/react-query';
import { getPerformanceByProductCategoryOvertime } from '../../../../api/executiveSummaryProductPerformanceApi';

const PerformanceByProductCategoryOvertime = withRouter((props: RouteComponentProps) => {
  const { history } = props;
  const { theme } = useContext(ThemeContext);

  const [filterDataBy, setFilteDataBy] = useState("Visits");

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["performanceByProductCategoryOvertimeData", history.location.search, filterDataBy],
    queryFn: () => getPerformanceByProductCategoryOvertime(filterDataBy),
    enabled: false,
  });

  useEffect(() => {
    refetch();
  }, [history.location.search, filterDataBy]);

  const handleFilterOptionClick = useCallback((evt: React.MouseEvent<HTMLElement>) => {
    const {
      currentTarget: { dataset },
    } = evt;
    const filterName = dataset?.filter;
    const optionValue = dataset?.value;

    if (filterName && optionValue) {
      setFilteDataBy(optionValue);
      eventTracking(MixpanelEvents.filter_change, { filter: filterName, value: optionValue, dashboard: "Executive Summary" });
    }
    closeFilterOptions();
  }, []);

  return (
    <div className="tile">
      <div className="tile-header">
        <div className="title-container">
          <div className="title">Performance by Product Category overtime</div>
          <Tooltip
            position="top"
            className={"normal_tippy"}
            trigger="mouseenter"
            animation="none"
            interactive={true}
            delay={1}
            hideDelay={1}
            duration={1}
            title={"Products that have received the biggest number of website visits within the selected date range and markets."}
            size={"small"}
          >
            <span className="info_tooltip" />
          </Tooltip>
        </div>
        <div className="filters-container">
          <DefaultFilter
            list={["Visits", "KBAs", "Leads"]}
            filterName={"ppco_filter_by"}
            filterLabel={"METRIC FILTER BY"}
            filterValue={filterDataBy}
            handleFilterOptionClick={handleFilterOptionClick}
          />
        </div>
      </div>
      <ExecutiveSummaryMultipleBarLineChart
        chartName="performanceByProductCategoryOvertimeChart"
        data={data?.data ?? []}
        seriesList={data?.series ?? []}
        theme={theme}
        isLoading={isLoading}
      />
    </div>
  )
});

export default PerformanceByProductCategoryOvertime